const FeltChanges = () => (
    <section id="felt-changes">
        <div className="container-fluid pt-4 pb-4 text-center gg-bg-solid-green-light">
            <div className="row align-items-center justify-content-center">
                <div className="col-md-8 col-11">
                    <p className="fw-light mb-4">He'd felt the changes.</p>
                    <p className="fw-light mb-4">The clearer mind. The lighter steps. The blood sugar finally behaving.<br />And with every capsule he took, hope began to replace fear.</p>
                    <p className="fw-light mb-4">But he also knew…</p>
                    <h5 className="mb-4 text-uppercase"><b>GlucoGen<sup>17</sup> isn’t mass-produced.</b></h5>
                    <p className="fw-light mb-4">Each batch takes weeks of careful fermentation.</p>
                    <p className="fw-light fst-italic mb-4">“I knew how limited the supply was. And the thought of going backwards… terrified me.”</p>
                </div>
            </div>
        </div>
    </section>
);

export default FeltChanges;